import { postJson } from "./http";

/**
 * Create the Round Off expense account, or adopt the one Zoho already has.
 *
 * Mapping an existing ledger does not use this call. That choice is saved as
 * an onboarding answer and writes nothing to the books.
 */
export interface RoundingOffAccountDTO {
  account_id: string;
  account_name: string;
  created: boolean;
}

interface CreateEnvelope {
  success: boolean;
  data: { account: RoundingOffAccountDTO };
}

export const createRoundingOffLedger = async (publicId: string): Promise<RoundingOffAccountDTO> =>
  (
    await postJson<CreateEnvelope>(
      "/api/onboarding/rounding-off/create",
      { public_id: publicId },
      ["rounding_off"]
    )
  ).data.account;

export interface TallyRoundingOffDTO {
  status: "ready" | "pending" | "failed";
  account_id: string | null;
  ledger_name: string | null;
  message: string;
}

interface TallyEnvelope {
  success: boolean;
  data: TallyRoundingOffDTO;
}

/** Queue Round Off in Tally, or report the ledger already on the chart. */
export const ensureTallyRoundingOff = async (publicId: string, retry = false): Promise<TallyRoundingOffDTO> =>
  (
    await postJson<TallyEnvelope>(
      "/api/onboarding/rounding-off/tally",
      { public_id: publicId, retry },
      ["rounding_off"]
    )
  ).data;
